import React from "react"
import { FeatureFlagReadModel, RenderBasedOnFlag } from "featureFlags"
import { ConsentProvider } from "cookiesConsent/features/getConsent"
import { ConsentStrategy } from "cookiesConsent/features/resolveConsent"
import { C15tRuntime } from "cookiesConsent/infrastructure/c15t/runtime"
import AnalyticsLifecycle from "cookiesConsent/infrastructure/segment/AnalyticsLifecycle"
import VisitorIdentityLifecycle from "cookiesConsent/infrastructure/segment/VisitorIdentityLifecycle"
import PublishConsentToGtm from "cookiesConsent/infrastructure/gtm/PublishConsentToGtm"
import { currentJurisdiction } from "cookiesConsent/infrastructure/edgeGeo/currentJurisdiction"
import { currentGeo } from "cookiesConsent/infrastructure/edgeGeo/currentGeo"

interface CookiesConsentProps {
  children: React.ReactNode
  flagReadModel?: FeatureFlagReadModel
}

const DeferredCookiesConsent = ({
  children,
  flagReadModel
}: CookiesConsentProps) => {
  const rules = currentJurisdiction()
  const { signal } = currentGeo()

  return (
    <C15tRuntime rules={rules} signal={signal}>
      <ConsentStrategy
        rules={rules}
        signal={signal}
        render={consent => (
          <ConsentProvider consent={consent}>
            {/* Rendered before AnalyticsLifecycle so the gtag consent update
                is queued before a decision starts the analytics load. */}
            <PublishConsentToGtm consent={consent} />
            <RenderBasedOnFlag
              flagName="ENABLE_IDENTITY_RESET_WEB_5097"
              flagReadModel={flagReadModel}
              FlagEnabledComponent={
                <VisitorIdentityLifecycle consent={consent} />
              }
              FlagDisabledComponent={<AnalyticsLifecycle consent={consent} />}
            />
            {children}
          </ConsentProvider>
        )}
      />
    </C15tRuntime>
  )
}

export default DeferredCookiesConsent
